import { Component, OnInit } from '@angular/core';
import { EventModel } from '../../models/api/EventModel';
import { BookingModel } from '../../models/api/BookingModel';
import { BookingService } from '../../services/api/BookingService';
import { EventService } from '../../services/api/EventService';
import { Router } from '@angular/router';
import { A11yModule } from "@angular/cdk/a11y";
import { MatButtonModule } from '@angular/material/button';
import { DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-event-list',
  standalone: true,
  imports: [A11yModule, MatButtonModule, DatePipe, MatIconModule],
  providers: [EventService, BookingService],
  templateUrl: './event-list.component.html',
  styleUrl: './event-list.component.scss'
})
export class EventListComponent implements OnInit {

  allEvents: EventModel[] = [];
  activeEvents: EventModel[] = [];

  private authUser = localStorage.getItem('AuthUser');

  isLoaded: boolean = false;
  private bookingGuid = localStorage.getItem('bookingGuid');
  bookingDetail = new BookingModel();

  constructor(
    private bookingService: BookingService,
    private eventService: EventService,
    private router: Router,
  ) {

  }

  ngOnInit(): void {

    //We first check if the user already had a booking in local storage or not. 
    //This allows us to redirect to the booking confirmation page if they do.
    if (this.bookingGuid) {
      this.bookingService.getBooking(this.bookingGuid).subscribe(data => {
        this.bookingDetail = data;

        if (this.bookingDetail && (this.bookingDetail.bookingStatusID === 2 || this.bookingDetail.bookingStatusID === 3 || this.bookingDetail.bookingStatusID === 4 || this.bookingDetail.bookingStatusID === 5)) {
          this.router.navigate(['client-portal', 'queue', this.bookingGuid]);
          return;
        } else {
          localStorage.removeItem('bookingGuid');
        }
      })
    }

    //check if is a logged in user and redirects if so!
    if (this.authUser) {

      const parsedUser = JSON.parse(this.authUser);
      console.log("client-portal:has auth user", parsedUser);
      //is admin
      if (parsedUser.user.userTypeID === 1 || parsedUser.user.userTypeID === 2) {
        console.log("client-portal:nav to admin");
        this.router.navigate(['admin', 'events']);
        return;
      }
      //is therapist
      else if (parsedUser.user.userTypeID === 3) {
        console.log("client-portal:nav to therapist dashboard");
        this.router.navigate(['therapist-portal', 'dashboard']);
        return;
      }
    }

    //Get the events

    this.eventService.getLiveEvents().subscribe({
      next: (data) => {
        //API returns events

        this.allEvents = data as EventModel[];
        const dateNow = new Date();

        // #1875 changed to do the filtering on the api side, so just trust the data coming back in.
        this.activeEvents = this.allEvents; //.filter(x => x.active && x.eventStatusID === 2 && new Date(x.startDate) <= dateNow && new Date(x.endDate) >= dateNow);

        //If we only have 1 active event - we can pre select the event for the user.
        if (this.activeEvents.length === 1) {
          const activeEvent = this.activeEvents[0];
          console.log("Event list redirect to therapist list");
          this.router.navigate(['client-portal/therapist-list'], { state: { eventID: activeEvent.eventID, eventName: activeEvent.eventName, eventStartDate: activeEvent.startDate, eventEndDate: activeEvent.endDate } });
        }

        this.isLoaded = true;

      },
      error: (err) => {
        //API fails to return any events
      }
    })


  }

  selectEvent(event: EventModel) {
    this.router.navigate(['client-portal/therapist-list'], { state: { eventID: event.eventID, eventName: event.eventName, eventStartDate: event.startDate, eventEndDate: event.endDate } });
  }


}
